import { c as _c } from "react/compiler-runtime";
import { Slot } from '@/components/ui/slot';
import { cn } from '@/lib/utils';
export interface DivProps extends React.ComponentProps<'div'> {}
export function Div(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      asChild: t1,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const asChild = t1 === undefined ? false : t1;
  const Component = asChild ? Slot : "div";
  let t2;
  if ($[5] !== className) {
    t2 = cn(className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== Component || $[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <Component className={t2} {...props}>{children}</Component>;
    $[7] = Component;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}